// Permissions were required to be sorted in a specific order
/* eslint-disable perfectionist/sort-enums */
export enum RolesPermissions {
  VIEW = 'VIEW_ROLES',
  UPDATE = 'UPDATE_ROLES',
}
